import React, { useEffect, useState } from 'react';
import { Button, Input, Select, Space, Tabs, Typography } from 'antd';
import { useOrderSearchForTicket, useTicketConfig, useTicketSlots } from './store';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { useConsultDoctor } from 'modules/dashboards/actionables/store';
import { toast } from 'react-toastify';
import moment from 'moment';
import ProductCalculation from './ProductCalculation';
import { currentUser, filterOption, getCurrentUserRole, getTatFormatedDate, noSlotInMedicalEscalation, ROLES_NAME, specialSubCategories } from 'modules/utilities/utility';
import { createMeidcalEscalationTicket } from 'modules/navbar/top/store';
import { isEmpty } from 'lodash';
import { get } from 'lodash';
import { useClinicStore } from 'modules/clinic-management/store';
import secureLocalStorage from 'react-secure-storage';
import { Tooltip } from 'antd';
import { CATEGORY, CUSTOMER_COMPLAINTS_SUBCATS } from 'modules/my_tickets/data';
const { MEDICAL_ESCALATIONS, NEGATIVE_REVIEWS_ORM, PAYMENTS, ORDER_RELATED, DAMAGED_PRODUCT, MISMATCH_PRODUCT, MISSING_PRODUCT, REVERSE_PICK_UP, PRODUCT_RELATED_QUALITY_ISSUES, COMMUNITY_ESCALATION, FIVE_MONTH_MONEY_BACK, CUSTOMER_COMPLAINTS, MEDICAL_DOCUMENT } = CATEGORY;
const { COMMUNITY, ORM, SUPER_ADMIN, MEDICAL_REP } = ROLES_NAME;
const { Text } = Typography;
import { LOCAL_STORAGE_CONFIG } from "config";
import { isComplaintTeam } from 'modules/navbar/top/helper';
const { CLINIC_ID } = LOCAL_STORAGE_CONFIG;
const role = getCurrentUserRole();

const CategoryAndSubcategory = ({ selectedOrder, shipmentAddress, setShipmentAddress, setTicketPayload, setSlotBookingPayload, setValidation }) => {
    const { fetchMedicalSlotData, allSlotData } = useConsultDoctor();
    const { ticketSlots, fetchTicketSlotData } = useTicketSlots();
    const { fetchCrmCategories, crmCategories } = useOrderSearchForTicket();
    const { fetchNearestSlot, nearestSlot } = createMeidcalEscalationTicket();
    const { clinicsAllData, getClnicDetails} = useClinicStore();
    const { ticketConfig } = useTicketConfig();

    const [slotMap, setSlotMap] = useState([])
    const [selectedSlot, setSelectedSlot] = useState({})
    const [categoriesToMap, setCategoryToMap] = useState([])
    const [selectedCategory, setSelectedCategory] = useState();
    const [selectedSubcategory, setSelectedSubcategory] = useState();
    const [subcategoryOptions, setSubcategoryOption] = useState([]);
    const [assigneeOptions, setAssigneeOptions] = useState([]);
    const [reamrkOptions, setRemarkOptions] = useState([]);
    const [tatDate, setTatDate] = useState()
    const [reasonFlag, setReasonFlag] = useState(false)
    const [remark, setRemark] = useState();
    const [clinicDoctors, setClinicDoctors] = useState([]);
    const [clinicReceptionist, setClinicReceptionist] = useState([]);

    const sessionId = uuidv4();
    const sessionIdforSlot = uuidv4();
    const clinic = ['clinic_doctor','clinic_receptionist'];
    const clinicAgent = clinic.includes(currentUser);

    const onSlotSelection = (slot) => {
        if(!_.isEmpty(slot)){setSelectedSlot(slot)};
        const slotData = {
            slotTime: slot.slotTime,
            availableSlots: slot.slots,
            isRescheduling: false,
            orderRelated: false,
            fromCrm: true,
        }
        if(selectedCategory === MEDICAL_ESCALATIONS){
            slotData.isMedicalEscalation = true;
            slotData.slotId = slot.id;
            slotData.sessionId = sessionIdforSlot
        }
        setSlotBookingPayload(prevPayload => ({
            ...prevPayload,
            ...slotData
        }));
    };

    useEffect(() => {
        if (clinicAgent) {
            const clinicId = secureLocalStorage.getItem("clinic_id");
            getClnicDetails(clinicId);
        }
        setValidation(prevValidation => ({ ...prevValidation, category: false, subcategory: false }));
    }, [])

    useEffect(() => {
        setSelectedCategory();
        setSelectedSubcategory();
    }, [selectedOrder.id]);

    useEffect(() => {
        if (crmCategories.length > 0) {
            const paymentIssue = crmCategories.filter(category => category.value === PAYMENTS);
            if (_.size(Object.keys(selectedOrder)) === 0) { setCategoryToMap(paymentIssue); }
            else { setCategoryToMap(crmCategories) }
        }
    }, [crmCategories])

    useEffect(() => {
        if (clinicAgent && !isEmpty(clinicsAllData)) {
            const clinicPersons = get(clinicsAllData, "clinic_persons", []);
            const doctors = clinicPersons.filter(person => get(person, "type", "") === "clinic_doctor").map((assignee) => ({ 'label': assignee.name, 'value': assignee.user_id }));;
            setClinicDoctors(doctors);
            const receptionists = clinicPersons.filter(person => get(person, "type", "") === "clinic_receptionist").map((assignee) => ({ 'label': assignee.name, 'value': assignee.user_id }));
            setClinicReceptionist(receptionists);
        }
    }, [clinicAgent, clinicsAllData, currentUser]);


    useEffect(() => { setCategoryToMap(crmCategories); }, [selectedOrder]);

    useEffect(() => {
        if (selectedCategory === MEDICAL_ESCALATIONS) {
            getSlotsMap(allSlotData);
        } else if(selectedCategory === CUSTOMER_COMPLAINTS ){
            // let slots = ticketSlots.slotsAfter20Min;
            // if(selectedSubcategory === FIVE_MONTH_MONEY_BACK){slots = ticketSlots.slotsAfter20Min}
            getSlotsMap(ticketSlots.slotsAfter20Min);
        }
    }, [allSlotData, ticketSlots, selectedSlot, selectedSubcategory]);


    const getSlotsMap = (slotData) => {
        if(selectedCategory === MEDICAL_ESCALATIONS || (selectedCategory === CUSTOMER_COMPLAINTS && CUSTOMER_COMPLAINTS_SUBCATS.includes(selectedSubcategory)) && !noSlotInMedicalEscalation(selectedSubcategory)){
            if (_.isArray(slotData) && !_.isEmpty(slotData)) {
                const slots = slotData.filter(slot => new Date(slot.slotTime).getHours() < 20)
                    .reduce((acc, slot) => {
                        const formattedDate = moment(slot.slotTime).format('DD-MM-YYYY');
                        if (!acc[formattedDate]) { acc[formattedDate] = [] }
                        acc[formattedDate].push({ slotLabel: moment(slot.slotTime).format('hh:mm A'), ...slot });
                        return acc;
                    }, {});
                
                const slotsData = Object.entries(slots).map(([label, slots], index) => {
                    const timeMap = slots.filter(slot => moment(slot.slotTime).isAfter(moment())).map(slot =>{
                        return selectedSlot.slotTime === slot.slotTime ?
                            <Button className='m-1' type='primary'>{slot.slotLabel}</Button> :
                            <Button className='m-1'
                                disabled={slot.slots.count === 0}
                                onClick={() => {
                                    setValidation(prevValidation => ({ ...prevValidation, slot: true }));
                                    onSlotSelection(slot)
                                }} >
                                {slot.slotLabel}
                            </Button>
                        })
                        
                        return { label: label, key: index + 1, children: <>{timeMap.map(time => time)}</> }
                    });
                setSlotMap(slotsData);
            }
        }
    };

    const onCategoryChange = (value) => {
        setValidation(prevValidation => {
            const { remark, ...rest } = prevValidation;
            return { ...rest }
        });
        if (value === PAYMENTS && Object.keys(selectedOrder).length === 0) {
            setValidation(prevValidation => ({ ...prevValidation, order_display_id: true }));
        }

        setTicketPayload(payload => {
            const data = { ...payload, category: value, sub_category: null, products: [], total_refund_price: '0.00' }
            value === PRODUCT_RELATED_QUALITY_ISSUES ? data.is_internal = true : data.is_internal = false;
            return data;
        })

        setValidation(prevValidation => ({ ...prevValidation, category: value ? true : false, subcategory: false }));

        setSelectedCategory(value);
        setSelectedSubcategory();
        setAssigneeOptions([]);
        setReasonFlag(false);

        if (value === undefined || value !== ORDER_RELATED) {
            setValidation(prevPayload => {
                const { request_type, products, ...rest } = prevPayload;
                return { ...rest };
            })
        }

        const subcategories = categoriesToMap.find(category => category.value === value);
        let subcategoriesToMap = _.get(subcategories, ['subcategory'], []);
        subcategoriesToMap = [ORM, SUPER_ADMIN].includes(role) ? subcategoriesToMap : subcategoriesToMap.filter(item => item.value !== NEGATIVE_REVIEWS_ORM);
        subcategoriesToMap = [COMMUNITY, SUPER_ADMIN].includes(role) ? subcategoriesToMap : subcategoriesToMap.filter(item => item.value !== COMMUNITY_ESCALATION);
        subcategoriesToMap = [MEDICAL_REP].includes(role) ? subcategoriesToMap.filter(item => item.value !== MEDICAL_DOCUMENT): subcategoriesToMap;
        if(value === PAYMENTS){
            subcategoriesToMap = isComplaintTeam() ? subcategoriesToMap : subcategoriesToMap.filter(item => item.value !== FIVE_MONTH_MONEY_BACK);
        }
        const subcatKeys = subcategoriesToMap.map(subcat => subcat.value);
        const order = _.get(selectedOrder, ['id'], 'default');
        const selectedOrderConfig = _.get(ticketConfig, [order], Object.values(ticketConfig)[0]);
        const filteredEntries = Object.entries(selectedOrderConfig).filter(([key]) => subcatKeys.includes(key));
        const filteredObject = Object.fromEntries(filteredEntries);

        subcategoriesToMap = subcategoriesToMap.map(subcat => ({...filteredObject[subcat.value], ...subcat }));

        setSubcategoryOption(subcategoriesToMap);

        if (value === MEDICAL_ESCALATIONS) {
            fetchNearestSlot();
            fetchMedicalSlotData(selectedOrder.case_id, sessionId, toast);
            setValidation(prevValidation => ({ ...prevValidation, slot: false }));
        } else {
            setValidation(prevValidation => {
                const { slot, ...rest } = prevValidation;
                return { ...rest };
            });
        }
    };

    const onSubcatChange = (value) => {
        if(selectedCategory === CUSTOMER_COMPLAINTS ){
            fetchTicketSlotData(value);
            setValidation(prevValidation => ({ ...prevValidation, slot: false }));
        } 
        if(selectedCategory === CUSTOMER_COMPLAINTS ){
            // const slots = value === FIVE_MONTH_MONEY_BACK ? ticketSlots.slotsAfter20Min : ticketSlots.slotsAfter30Min;
            getSlotsMap(ticketSlots.slotsAfter20Min);
        };

        if (specialSubCategories.includes(value)) {
            setTicketPayload(prevPayload => ({ ...prevPayload, slotTime: nearestSlot?.slot_time }));
            setValidation(prevValidation => {
                const { slot, ...rest } = prevValidation;
                return { ...rest }
            });
        } else if (selectedCategory === MEDICAL_ESCALATIONS && !noSlotInMedicalEscalation(value)) {
            setTicketPayload(prevPayload => {
                const { slotTime, ...rest } = prevPayload;
                return { ...rest }
            });
            setValidation(prevValidation => ({ ...prevValidation, slot: false }));
        } else {
            setValidation(prevValidation => {
                const { slot, slotTime, ...rest } = prevValidation;
                return { ...rest };
            });
            setTicketPayload(prevPayload => {
                const { slotTime, ...rest } = prevPayload;
                return { ...rest }
            });
        }
        setSelectedSubcategory(value);
        setValidation(prevValidation => ({ ...prevValidation, subcategory: value ? true : false }));

        const selectedSubcat = subcategoryOptions.find(subcat => subcat.value === value)

        if (selectedSubcat){
            if(selectedSubcat.reasonFlag) { setValidation(prevValidation => ({ ...prevValidation, remark: false })); }
            setReasonFlag(selectedSubcat.reasonFlag);
            setTicketPayload(prevPayload => ({ ...prevPayload, remark: '' }));
            setRemarkOptions(selectedSubcat?.reasons.map(({ label }) => ({ value: label, label: label })));
    
            const tat = getTatFormatedDate(selectedSubcat.tat);
            setTatDate(tat);
            const dueDate = moment(tat).toISOString();
    
            setTicketPayload(prevPayload => {
                const category = prevPayload.category;
                const subcategory = value;
                const providerMeta = prevPayload.provider_meta;
                providerMeta.subject = providerMeta.subject || '';
                providerMeta.subject = providerMeta.subject.split(':')[0] + `: ${category} --> ${value}`;
                return { ...prevPayload, sub_category: subcategory, provider_meta: { ...prevPayload.provider_meta, due_date: dueDate }, due_date: dueDate }
            })
    
            const assignees = selectedSubcat.assignees.map(assignee => ({ label: assignee.firstName, value: assignee.userId }));
            if (_.size(assignees) > 0) { setTicketPayload(payload => ({ ...payload, current_assignment: assignees[0].value })) };
            setAssigneeOptions(assignees);
        }
    }

    const onAssigneeChange = id => setTicketPayload(prevPayload => ({ ...prevPayload, current_assignment: id || assigneeOptions[0].userId }))

    return <>
        <Space.Compact block className='my-2'>
            <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }} className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                <Text>Select Category</Text>
            </span>
            <Select
                style={{ width: '70%' }}
                showSearch
                allowClear
                placeholder='Select a Category'
                optionFilterProp='children'
                value={selectedCategory}
                onChange={onCategoryChange}
                filterOption={filterOption}
                options={categoriesToMap.filter(Boolean)}
            />
        </Space.Compact>

        <Space.Compact block className='my-3'>
            <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                <Text>Select Subcategory</Text>
            </span>
            <Select
                style={{ width: '70%' }}
                showSearch
                allowClear
                placeholder='Select a subcategory'
                optionFilterProp='children'
                value={selectedSubcategory}
                onChange={onSubcatChange}
                filterOption={filterOption}
            >
                {subcategoryOptions.map((option) => {
                    return <Select.Option
                        disabled={!option.isDisabled}
                        value={option.value}>
                        <Tooltip title={option.tooltip}><span>{option.label}</span></Tooltip>
                    </Select.Option>
                })}
            </Select>
        </Space.Compact>

        {reasonFlag && <Space.Compact block className='my-3'>
            <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                <Text>Remark</Text>
            </span>
            <Select
                style={{ width: '70%' }}
                showSearch
                allowClear
                placeholder='Select a reason'
                optionFilterProp='children'
                value={remark}
                onChange={(value) => {
                    setRemark(value);
                    setValidation(prevValidation => ({ ...prevValidation, remark: value ? true : false }));
                    setTicketPayload(prevPayload => ({ ...prevPayload, remark: value }));
                }}
                filterOption={filterOption}
                options={reamrkOptions}
            />
        </Space.Compact>}

        {selectedCategory === ORDER_RELATED && [DAMAGED_PRODUCT, MISMATCH_PRODUCT, MISSING_PRODUCT, REVERSE_PICK_UP].includes(selectedSubcategory) &&
            <ProductCalculation order={selectedOrder} shipmentAddress={shipmentAddress} setShipmentAddress={setShipmentAddress} setTicketPayload={setTicketPayload} setValidation={setValidation} />}

        {selectedCategory === MEDICAL_ESCALATIONS || (selectedCategory === CUSTOMER_COMPLAINTS && CUSTOMER_COMPLAINTS_SUBCATS.includes(selectedSubcategory)) && !noSlotInMedicalEscalation(selectedSubcategory) ?
            <>
                {!specialSubCategories.includes(selectedSubcategory) ?
                    <>
                        {clinicAgent ? <div className='d-flex gap-2'>
                            <Space.Compact block className='my-3'>
                                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }} className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                    <Text>Receptionist</Text>
                                </span>
                                <Select
                                    style={{ width: '70%' }}
                                    showSearch
                                    allowClear
                                    defaultValue='Default Receptionist'
                                    placeholder='Select Receptionist'
                                    optionFilterProp='children'
                                    onChange={onAssigneeChange}
                                    filterOption={filterOption}
                                    options={clinicReceptionist}
                                    disabled={_.size(clinicReceptionist) === 0}
                                />
                            </Space.Compact>
                            <Space.Compact block className='my-3'>
                                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                                    <Text>Doctor</Text>
                                </span>
                                <Select
                                    style={{ width: '70%' }}
                                    showSearch
                                    allowClear
                                    defaultValue='Default Doctor'
                                    placeholder='Select Doctor'
                                    optionFilterProp='children'
                                    onChange={onAssigneeChange}
                                    filterOption={filterOption}
                                    options={clinicDoctors}
                                    disabled={_.size(clinicDoctors) === 0}
                                />
                            </Space.Compact>
                        </div> : null}
                        <Tabs defaultActiveKey='1' type='card' size={'middle'} items={slotMap} />
                    </>
                    :
                    <Space.Compact block className='my-3'>
                        <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                            className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                            <Text>Nearest Slot</Text>
                        </span>
                        <Input style={{ width: '70%' }} value={nearestSlot ? moment(nearestSlot?.slot_time).format('hh:mm, MMMM Do YYYY') : '-'} />
                    </Space.Compact>
                }
            </> :
            <Space.Compact block className='my-3'>
                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                    <Text>Select Assignee</Text>
                </span>
                <Select
                    style={{ width: '70%' }}
                    showSearch
                    allowClear
                    defaultValue='Default Assignee'
                    placeholder='Select assignee'
                    optionFilterProp='children'
                    onChange={onAssigneeChange}
                    filterOption={filterOption}
                    options={assigneeOptions}
                    disabled={_.size(assigneeOptions) === 0}
                />
            </Space.Compact>
        }

        {selectedCategory !== 'medical_escalations' && <Space.Compact block className='my-3'>
            <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                <Text>{`Due By (${Math.ceil(moment(tatDate).diff(moment(), 'days', true))} days)`}</Text>
            </span>
            <Input style={{ width: '70%' }} value={tatDate} />
        </Space.Compact>}

    </>
};
export default CategoryAndSubcategory